var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgTenbisCreditSmall = function SvgTenbisCreditSmall(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 16,
    fill: "none",
    ref: ref
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 16,
    fill: "#F36805",
    rx: 3
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    clipPath: "url(#tenbisCreditSmall_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m9.295 5.605.163-.412a.9.9 0 0 1 .512-.463c.232-.087.492-.088.725-.002l2.332.877zM8.894 10.228a.26.26 0 0 0 .173-.064.21.21 0 0 0 .071-.156V8.245a.2.2 0 0 0-.043-.118.2.2 0 0 0-.079-.071.3.3 0 0 0-.106-.032H6.98v-.827c0-.228.1-.446.277-.607s.42-.25.672-.25h5.56c.14-.005.281.018.411.068q.168.075.291.202a.8.8 0 0 1 .181.288.7.7 0 0 1 .066.299v3.918a.82.82 0 0 1-.28.604c-.178.16-.418.252-.67.253h-5.56a1 1 0 0 1-.669-.252.82.82 0 0 1-.28-.605v-.887z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.325 8.759v.73H6.453v-.73zM7.533 4.675q.091-.092.191-.172c.18-.144.18-.497 0-.641a2.2 2.2 0 0 1-.351-.355c-.144-.183-.506-.183-.65 0a2.2 2.2 0 0 1-.352.355c-.18.144-.18.497 0 .64a2.2 2.2 0 0 1 .352.355c.144.183.506.183.65 0q.075-.095.16-.182M5.664 3.087a1 1 0 0 1 .12-.107c.112-.09.112-.311 0-.401a1.4 1.4 0 0 1-.22-.222c-.09-.114-.316-.114-.406 0a1.4 1.4 0 0 1-.22.222c-.112.09-.112.31 0 .4a1.4 1.4 0 0 1 .22.222c.09.115.316.115.406 0q.047-.06.1-.114"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "tenbisCreditSmall_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M4.594 2h9.844v10H4.594z"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgTenbisCreditSmall);
export default ForwardRef;